import * as React from "react";
import { BulkExportContext } from "./BulkExportContext";
import { BulkExportService } from "./services/BulkExportService2";

export const defaultBulkExportContext = new BulkExportContext();
export const BulkExportContextReact = React.createContext<BulkExportContext>(defaultBulkExportContext);
export const BulkExportServiceContextReact = React.createContext<BulkExportService | undefined>(undefined);
